import React, { useRef, useState } from "react";
import axios from "axios"; // Import axios for API requests
import ContactBanner from "../assets/images/contactus-banner.jpg";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { CustomInput, CustomTextArea } from "../components/Input/input";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { API_BASE_URL } from "../utils/constants";
import Map from "../components/Map/Map";

const Contact = () => {
  const toast = useRef(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const Links = ({ Icon, info }) => {
    return (
      <div className="flex align-items-center gap-2 cursor-pointer">
        <Icon />
        <p>{info}</p>
      </div>
    );
  };

  const handleChange = ({ target: { name, value } }) => {
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(API_BASE_URL + "/api/contact/", data); // Replace with your API URL
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Your message has been successfully submitted!",
      });
      setData({}); // Reset the form
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Something went wrong, please try agian!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <Toast ref={toast} />
      <div className="h-19rem">
        <img src={ContactBanner} alt="Shah transport" className="responsive" />
      </div>
      <div className="flex flex-wrap flex-column-reverse lg:flex-row p-3 md:p-6 m-0 ">
        <div className="col-12 md:col-6 p-3 border-round-xl shadow-3 ">
          <h2>Request a call back</h2>
          <small>
            Please fill your details below and our representative will get in
            touch with you.
          </small>
          <form onSubmit={handleSubmit} className="mt-5">
            <div className="flex flex-wrap">
              <CustomInput
                label="Subject"
                name="subject"
                value={data?.subject || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Name"
                name="name"
                value={data?.name || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Email"
                name="email"
                value={data?.email || ""}
                onChange={handleChange}
              />
              <CustomInput
                label="Phone Number"
                name="phone"
                value={data?.phone || ""}
                onChange={handleChange}
              />
              <CustomTextArea
                label="Your Message"
                name="message"
                value={data?.message || ""}
                onChange={handleChange}
              />
              <Button
                label={loading ? "Submitting..." : "Submit"}
                severity="secondary"
                className="mt-4 mx-2"
                type="submit"
                disabled={loading}
              />
            </div>
          </form>
        </div>
        <div className="col-12 md:col-2"></div>
        <div className="col-12 md:col-4 ">
          <h2>Shah Transport Limited</h2>
          <small>
            <Links Icon={FaPhoneAlt} info="(905)-216-3424" />
            <Links Icon={MdEmail} info="dispatch@shahtransport.com" />
            <Links Icon={FaClock} info="Mon- Sat : 07:00 AM - 07:00 PM" />
            <Links
              Icon={FaLocationDot}
              info="Office : 5758 Dixie Rd, Mississauga ON L4W 1E7"
            />
            <Links
              Icon={MdEmail}
              info="Mailing : 23 Alamosa Crt, Brampton ON L6Y 2Z3"
            />
          </small>
        </div>
      </div>
      <Map/>
    </div>
  );
};

export default Contact;
